const newRFPMessageText = (userInfo) => {return (
`👋 Hey there, ${userInfo.firstName}! Excited to help you craft your RFP.
        
To kick things off, tell me a bit about your company — or drop in your “About Us” section if you’ve got one handy.
    
That’ll help me tailor the RFP to your vibe and goals.`
)}



export const newRFPMessage = (userInfo) => {return ({ role: "model", parts: [{ text: newRFPMessageText(userInfo)}] });}